export default __webpack_public_path__ + "static/badge_bluejay-535515625eb83d3c82eb6d8c30121e06.png";